import { Col, Empty, Row } from "antd"
import { ProfilePageData } from "libs/profile-repo"
import { dateFormat, getEnumLabel } from "libs/utils"
import ProfileAttachment from "./ProfileAttachment"
import ProfileDetailItem from "./ProfileDetailItem"
import ProfileTitle from "./ProfileTitle"

export default function ProfileAuthDetail({
  authDetail,
  enumState,
  qualificationEncoding,
}: ProfilePageData) {
  function buildRegisterValidDate() {
    const {
      registerValidFrom,
      registerValidTo,
      registerValidLongTerm,
    } = authDetail.auditFormDetail.mainInfo
    if (!registerValidFrom && !registerValidTo && !registerValidLongTerm) {
      return "暂无"
    } else {
      const from = registerValidFrom ? dateFormat(registerValidFrom) : "暂无"
      const to = registerValidLongTerm
        ? "长期"
        : registerValidTo
        ? dateFormat(registerValidTo)
        : "暂无"
      return `${from}至${to}`
    }
  }

  function getNameByCode(list, code) {
    let name = ""
    list.forEach((item) => {
      if (item.code === code) {
        name = item.name
        return name
      }
    })
    return name
  }

  function getNameByQualificationType(item) {
    const SupplierQualificationTypeEnum =
      enumState.SupplierQualificationTypeEnum
    let qualificationType = item.qualificationType
    let list = []
    if (qualificationType === SupplierQualificationTypeEnum?.LICENCE?.value) {
      list = qualificationEncoding.licenceList
    } else if (
      qualificationType ===
      SupplierQualificationTypeEnum?.SYSTEM_CERTIFICATION?.value
    ) {
      list = qualificationEncoding.systemCertificationList
    } else if (
      qualificationType === SupplierQualificationTypeEnum?.OTHERS?.value
    ) {
      return item.name
    }
    return getNameByCode(list, item.nameCode)
  }

  return (
    <div className="auth-detail-content-wrap">
      <div>
        <ProfileTitle title="企业信息" marginTop="0" marginBottom="18px" />
        <Row gutter={20}>
          <Col span={8}>
            <ProfileDetailItem label="公司名称" labelWidth="84px">
              {authDetail.auditFormDetail.mainInfo.name}
            </ProfileDetailItem>
          </Col>

          <Col span={8}>
            <ProfileDetailItem label="统一社会信用代码" labelWidth="122px">
              {authDetail.auditFormDetail.mainInfo.unifiedSocialCode}
            </ProfileDetailItem>
          </Col>
        </Row>
        <Row>
          <ProfileDetailItem label="主营业务" labelWidth="80px">
            {authDetail.supplierUser?.admittanceCategoryList
              ?.map((item) => item.name)
              ?.join("、")}
          </ProfileDetailItem>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <ProfileDetailItem label="企业类型" labelWidth="84px">
              {getEnumLabel({
                enums: enumState.SupplierCompanyTypeEnum,
                value: authDetail.auditFormDetail.mainInfo.companyType,
              })}
            </ProfileDetailItem>
          </Col>
          <Col span={8}>
            <ProfileDetailItem label="注册资本" labelWidth="80px">
              {authDetail.auditFormDetail.mainInfo.registerFund}万元
            </ProfileDetailItem>
          </Col>
          <Col span={8}>
            <ProfileDetailItem label="成立日期" labelWidth="122px">
              {dateFormat(authDetail.auditFormDetail.mainInfo.registerDate)}
            </ProfileDetailItem>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <ProfileDetailItem label="营业期限" labelWidth="84px">
              {buildRegisterValidDate()}
            </ProfileDetailItem>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <ProfileDetailItem label="法定代表人" labelWidth="84px">
              {authDetail.auditFormDetail.mainInfo.legalManName}
            </ProfileDetailItem>
          </Col>
          <Col span={8}>
            <ProfileDetailItem label="联系人" labelWidth="80px">
              {authDetail.supplierUser.displayName}
            </ProfileDetailItem>
          </Col>
          <Col span={8}>
            <ProfileDetailItem label="注册所在地" labelWidth="84px">
              {authDetail.auditFormDetail.mainInfo.areaFullName}
            </ProfileDetailItem>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={16}>
            <ProfileDetailItem label="详细地址" labelWidth="80px">
              {authDetail.auditFormDetail.mainInfo.contactAddress}
            </ProfileDetailItem>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <ProfileDetailItem label="营业执照" labelWidth="84px">
              <ProfileAttachment
                item={
                  authDetail.auditFormDetail.mainInfo?.registerCardAttachment
                }
              />
            </ProfileDetailItem>
          </Col>
        </Row>
      </div>
      <div>
        <ProfileTitle title="资质文件" marginTop="20px" marginBottom="22px" />
        {authDetail.auditFormDetail?.qualificationFile
          ?.qualificationFileInfoList?.length ? (
          authDetail.auditFormDetail?.qualificationFile?.qualificationFileInfoList.map(
            (item, index) => (
              <div className="qualification-card-wrap" key={index}>
                <div className="card-number">{index + 1}</div>
                <div className="card-content">
                  {item.qualificationType ===
                  enumState.SupplierQualificationTypeEnum
                    ?.INDUSTRY_QUALIFICATION.value ? (
                    <Row gutter={20}>
                      <Col span={12}>
                        <ProfileDetailItem label="资质类型" labelWidth="66px">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationTypeEnum,
                            value: item.qualificationType,
                          })}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质序列" labelWidth="66px">
                          {getNameByCode(
                            qualificationEncoding.sequenceCodeList,
                            item.sequenceCode,
                          )}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质专业" labelWidth="66px">
                          {getNameByCode(
                            qualificationEncoding.professionNameList,
                            item.professionCode,
                          )}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质等级" labelWidth="66px">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationFileLevelEnum,
                            value: item.level,
                          })}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质文件" labelWidth="66px">
                          {item.attachment.map((fileItem, fileIndex) => (
                            <ProfileAttachment
                              key={fileIndex}
                              item={fileItem}
                            />
                          ))}
                        </ProfileDetailItem>
                      </Col>
                    </Row>
                  ) : (
                    <Row gutter={20}>
                      <Col span={12}>
                        <ProfileDetailItem label="资质类型" labelWidth="66px">
                          {getEnumLabel({
                            enums: enumState.SupplierQualificationTypeEnum,
                            value: item.qualificationType,
                          })}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质名称" labelWidth="66px">
                          {getNameByQualificationType(item) || item.subName}
                        </ProfileDetailItem>
                      </Col>
                      <Col span={12}>
                        <ProfileDetailItem label="资质文件" labelWidth="66px">
                          {item.attachment.map((fileItem, fileIndex) => (
                            <ProfileAttachment
                              key={fileIndex}
                              item={fileItem}
                            />
                          ))}
                        </ProfileDetailItem>
                      </Col>
                    </Row>
                  )}
                </div>
              </div>
            ),
          )
        ) : (
          <div className="empty-wrap">
            <Empty />
          </div>
        )}
      </div>
      <style jsx>{`
        .empty-wrap {
          padding-bottom: 25px;
        }
        .auth-detail-content-wrap {
          padding: 14px 20px 0 20px;
          line-height: 1;
        }
        .qualification-card-wrap {
          padding: 12px 12px 22px 12px;
          display: flex;
          align-items: flex-start;
          border-top: 1px solid #f1f1f1;
        }
        .card-number {
          padding: 3px 6px;
          background: #ffffff;
          border: 1px solid var(--primaryColor);
          border-radius: 1px;
          font-size: 14px;
          color: var(--primaryColor);
          font-weight: bold;
          margin-top: 8px;
        }
        .card-content {
          padding-left: 23px;
          flex: 1;
        }
      `}</style>
    </div>
  )
}
